import {
  default as createjobpage,
  default as editjobpage,
} from "@/projects/Hrms/pages/EmployeeFormPage";
import {
  default as createleavepage,
  default as editleavepage,
} from "@/projects/Hrms/pages/LeaveFormPage";
import {
  default as createperformancepage,
  default as editperformancepage,
} from "@/projects/Hrms/pages/Performanceformpage";
import {
  default as createemplifecyclepage,
  default as editemplifecyclepage,
} from "@/projects/Hrms/pages/EmployeeLifecycleformpage";

import joblistpage from "@/projects/Hrms/pages/EmployeeListPage";
import HRMSNavigationRoutes from "./navigationRoutes";
import leavelistpage from "@/projects/Hrms/pages/LeaveListPage";
import performancelistpage from "@/projects/Hrms/pages/Performancelistpage";
import employeelifecyclepage from "@/projects/Hrms/pages/EmployeeLifecyclelistpage";
const HRMSRoutes = {
  // Employee/job routes
  createjob: {
    path: HRMSNavigationRoutes.ADD_EMP,
    component: createjobpage,
    name: "Create Job",
  },
  editjob: {
    path: HRMSNavigationRoutes.EDIT_JOB_ROUTE,
    component: editjobpage,
    name: "Edit Job",
  },
  joblist: {
    path: HRMSNavigationRoutes.EMP_LIST,
    component: joblistpage,
    name: "Job List",
  },

  // Leave routes
  createleave: {
    path: HRMSNavigationRoutes.ADD_LEAVE,
    component: createleavepage,
    name: "Create Leave",
  },
  editleave: {
    path: HRMSNavigationRoutes.EDIT_LEAVE_ROUTE,
    component: editleavepage,
    name: "Edit Leave",
  },
  leavelist: {
    path: HRMSNavigationRoutes.LEAVE_LIST,
    component: leavelistpage,
    name: "Leave List",
  },

  // Performance routes
  createperformance: {
    path: HRMSNavigationRoutes.ADD_PERFORMANCE,
    component: createperformancepage,
    name: "Create Performance",
  },
  editperformance: {
    path: HRMSNavigationRoutes.EDIT_PERFORMANCE_ROUTE,
    component: editperformancepage,
    name: "Edit Performance",
  },
  performancelist: {
    path: HRMSNavigationRoutes.PERFORMANCE_LIST,
    component: performancelistpage,
    name: "Performance List",
  },

  // Employee Lifecycle routes
  createemplifecycle: {
    path: HRMSNavigationRoutes.ADD_EMP_LIFECYCLE,
    component: createemplifecyclepage,
    name: "Create Employee Lifecycle",
  },
  editemplifecycle: {
    path: HRMSNavigationRoutes.EDIT_EMP_LIFECYCLE_ROUTE,
    component: editemplifecyclepage,
    name: "Edit Employee Lifecycle",
  },
  employeelifecycle: {
    path: HRMSNavigationRoutes.EMP_LIFECYCLE_LIST,
    component: employeelifecyclepage,
    name: "Employee Lifecycle List",
  },
};

export default HRMSRoutes;
